import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';

import { RewardTokenType } from 'packages/sports/web/app/src/tokens-base/token-base.models';

import { TokenPayoutSummary } from '../../models/betslip-result-summary.model';

@Component({
    selector: 'bs-token-payout-summary',
    templateUrl: './result-token-payout-summary.component.html',
    styleUrls: ['./result-token-payout-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultTokenPayoutComponent {
    @HostBinding('class') className = 'reward-tokens-module';

    readonly tokenPayoutSummary = input.required<TokenPayoutSummary>();
    readonly isAccaBoost = computed(() => this.tokenPayoutSummary().tokenType === RewardTokenType.AccaBoost);
}
